/**
 * Kleiner Trend-Indikator: Pfeil + Δ in Prozentpunkten vs. vor ~30 Tagen.
 * null/undefined ⇒ "—" mit Tooltip "Trend im Aufbau". Beim Drop-Risiko ist
 * steigend schlecht (rot) und fallend gut (grün).
 */
import { Minus, TrendingDown, TrendingUp } from "lucide-react";

export function TrendBadge({
  trendPp,
  size = 11,
}: { trendPp: number | null | undefined; size?: number }) {
  if (trendPp === null || trendPp === undefined) {
    return (
      <span
        title="Trend im Aufbau — es werden täglich Daten gesammelt"
        className="text-[10px]"
        style={{ color: "var(--text-muted)" }}
      >
        —
      </span>
    );
  }
  const rising = trendPp >= 2;
  const falling = trendPp <= -2;
  const color = rising ? "var(--risk-high)" : falling ? "var(--risk-low)" : "var(--text-muted)";
  const Icon = rising ? TrendingUp : falling ? TrendingDown : Minus;
  return (
    <span
      className="inline-flex items-center gap-1 text-[11px] font-mono-data font-medium"
      style={{ color }}
      title="Veränderung des Drop-Risikos gegenüber vor 30 Tagen"
    >
      <Icon size={size} />
      {trendPp > 0 ? `+${trendPp}` : trendPp}pp
    </span>
  );
}
